import { MDL2Customizations } from '@uifabric/mdl2-theme';
import { Theme } from '@fluentui/theme';

export const MDL2Theme: Theme = MDL2Customizations.settings.theme;
